<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.customLmraLists.buildingListTitle')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_critical_error">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-form>
              <template v-for="(item) in currentThreeStateList.customQuestions">
                <three-state-cb
                    :key="item.key"
                    :checkbox_id="item.key"
                    @3SCBChanged="threeStateBoxChanged"
                    :label="item.display_value"
                    :cb_type="'3SCB'"
                    :state="item.current_state"
                    :disabled="formDisabled"
                ></three-state-cb>
              </template>
              <!-- we use this three-state-cb for DQI -->
              <three-state-cb
                  v-if="dynamicQuestion"
                  :checkbox_id="'DQI'"
                  @3SCBChanged="dynamicQuestionStateChanged"
                  :label="dynamicQuestion.question"
                  :cb_type="'DQI'"
                  ref="dynamicQuestion"
                  :state="dynamicQuestionState"
                  :disabled="formDisabled"
              ></three-state-cb>
              <!-- Send btn -->
              <v-btn block color="primary" @click.prevent="openRemarks()" :disabled="formDisabled">
                {{ $vuetify.lang.t('$vuetify.global.confirmAndSend') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <crit-err :shown="has_critical_error" :title="$vuetify.lang.t('$vuetify.customLmraLists.criticalErrorTitle')"
              code="CE-C3SL-INVALID-LIST-00" :is_cancelable="true" :closeBtnText="$vuetify.lang.t('$vuetify.global.ok')"
              :interceptsClose="true" @closeClicked="emitForceLoadDefaultLmraComponent">
      {{ $vuetify.lang.t('$vuetify.customLmraLists.criticalErrorBody') }}
    </crit-err>
    <remarks-popup :initial_remarks="user_remarks" :is-visible="showRemarksPopup" :max-length="255" @closed="closePopup"
                   :disabled="formDisabled"></remarks-popup>
    <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>

  </v-container>
</template>

<script>
import ThreeStateCheckboxComponent from "../global/three-state-checkbox/ThreeStateCheckboxComponent";
import RemarksInputComponent from "../global/remarksInput/RemarksInputComponent";
import PrivateLocationCheckComponent from "../global/privateLocationChecker/PrivateLocationCheckComponent";
import DynamicQuestionMixinForLMRA from "../../../mixins/dynamicQuestionMixinForLMRA/DynamicQuestionMixinForLMRA";
import GettingDataOverlayComponent from "../global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import CriticalAppErrorComponent from "../global/criticalAppError/CriticalAppErrorComponent";
import {WORK_STATE_START} from "../../../mixins/LMRADataObjectBuilder/LMRADataObjectBuilder";
import {CustomLmraListsHelper} from "@/helpers/customLmraLists/CustomLmraListsHelper";
import LMRAVCChildComponentMixin from "@/mixins/LMRAViewComponent/LmraViewComponentChildComponentMixin";
import {ENTRY_DATA_KEY, LMRADataObjectHelper} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import LmraVariantWorkSessionMixin from "@/workSessions/mixins/LmraVariantWorkSessionMixin";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

export default {
  name: "StaticThreeStateLmra",
  mixins: [DynamicQuestionMixinForLMRA, LMRAVCChildComponentMixin , LmraVariantWorkSessionMixin],
  components: {
    gettingDataOverlay: GettingDataOverlayComponent,
    threeStateCb: ThreeStateCheckboxComponent,
    remarksPopup: RemarksInputComponent,
    locationPopup: PrivateLocationCheckComponent,
    critErr: CriticalAppErrorComponent,
  },
  data: () => {
    return {
      is_loading: false,
      has_critical_error: false,
      dynamicQuestionState: -1,
      currentThreeStateList: {},
      user_id: null,
      formDisabled: false,
      showRemarksPopup: false,
      showPrivateLocationPopup: false,
      user_remarks: '',
    }
  },
  methods: {
    dynamicQuestionStateChanged($event) {
      if ($event.id === 'DQI') {
        //console.log('changing state');
        this.dynamicQuestionState = $event.state;
        //console.log(this.dynamicQuestionState);
      }
    },
    threeStateBoxChanged($event) {
      //console.log($event.id);
      //console.log('BEFORE');
      //console.log(this.customQuestions);
      this.currentThreeStateList.customQuestions.find(x => x.key === $event.id)['current_state'] = $event.state;
      //console.log('AFTER');
      //console.log(this.customQuestions);
    },
    openRemarks() {
      //console.log('CLICK');
      //console.log(this.checkboxes.cb_pbm)
      this.showRemarksPopup = true;
    },
    gatherCurrentQuestionStatesForDataTransfer() {
      let currentStateData = {};
      for (const item of this.currentThreeStateList.customQuestions) {
        currentStateData[item.key] = item.current_state;
      }
      return currentStateData;

    },
    closePopup($event) {
      this.showRemarksPopup = false;
      this.user_remarks = $event.remarks;
      if ($event.userConfirmed) {
        this.showPrivateLocationPopup = true;
      }
    },
    async save() {
      this.formDisabled = true;
      this.showPrivateLocationPopup = false;
      let dataObject = await LMRADataObjectHelper.buildBaseLmraDataObject();
      dataObject[ENTRY_DATA_KEY]['remarks'] = this.user_remarks;
      dataObject[ENTRY_DATA_KEY]['work_state'] = WORK_STATE_START;

      dataObject[ENTRY_DATA_KEY]['list_key'] = this.currentThreeStateList.key;
      dataObject[ENTRY_DATA_KEY]['questions_data'] = this.gatherCurrentQuestionStatesForDataTransfer();
      //STILL ORIGINAL APPROACH LOOK INTO IT
      dataObject[ENTRY_DATA_KEY]['dynamic_question'] = {
        "question": this.dynamicQuestion,
        "answer": this.dynamicQuestionState
      }


      //console.log(dataObject);

      /* START SENDING PART (DIFFERENT THAN OTHERS!!) */
      await lmraDataRepositoryApi.sendCustomLmra(dataObject)
          .then(response => {
            this.handleLMRAVariantServerResponse(response.data);
          })
          .catch(err => {
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + err.message);
            this.formDisabled = false;
          });
      /* END SENDING PART */
    },
    async initQuestionList() {
      this.is_loading = true;
      let $listData = await CustomLmraListsHelper.getCurrentValidatedCustomLmraList();
      let processedData = await this.processStaticListData($listData);
      if (!this.has_critical_error) {
        this.currentThreeStateList = processedData;
      }
      this.is_loading = false;
    },
    async processStaticListData($listData) {
      //CHECK VALID THREE STATE OBJECT
      if (!CustomLmraListsHelper.isValidThreeStateQuestionListObject($listData)) {
        this.has_critical_error = true;
        return null;
      }

      var processedQuestionList = this.buildStaticThreeStateQuestionList($listData);

      if (processedQuestionList.customQuestions === undefined || processedQuestionList.customQuestions.length <= 0) {
        this.has_critical_error = true;
      }

      return processedQuestionList;
    },
    buildStaticThreeStateQuestionList(data) {
      /* window.console.log('entered the threeStateQuestionBuilder')
       window.console.log(data);*/
      let newProcessedQuestionList = {
        key: data.key,
        customQuestions: []
      }

      //OF
      for (const item of data.custom_lmra_questions) {
        /*window.console.log('FOUND an ITEM');
        window.console.log(item);*/
        if (item.key === undefined || item.key.length <= 0 || item.default === undefined) {
          continue;
        }

        let new_question = {
          key: item.key,
          current_state: -1
        }

        let display_value = this.getItemDisplayValue(item);

        new_question['display_value'] = display_value;

        newProcessedQuestionList.customQuestions.push(new_question);

      }

      return newProcessedQuestionList;
    },
    getItemDisplayValue(item) {
      if (item.translation !== undefined && item.translation !== null && item.translation.length > 0) {
        return item.translation;
      } else {
        return item.default;
      }
    }
  },
  async created() {
    this.user_id = this.$store.getters.getUserId;
  },
  async mounted() {
    this.is_loading = true;
    await this.getNewDynamicQuestion();
    this.initQuestionList();
  }
}
</script>

<style scoped>

</style>